import Icon from '../components/Icon.vue'

Icon.register({"book-open":{"width":576,"height":512,"paths":[{"d":"M542.2 0.1C487.4 3.2 378.5 14.5 311.2 55.7 306.6 58.5 303.9 63.6 303.9 68.9V432.8C303.9 444.3 316.5 451.6 327.2 446.3 396.4 411.5 496.4 402 545.9 399.4 562.8 398.5 575.9 385 575.9 368.7V30.7C576 13 560.6-1 542.2 0.1zM264.7 55.6C197.5 14.5 88.6 3.2 33.8 0.1 15.4-1 0 13 0 30.7V368.5C0 384.7 13.1 398.3 30 399.2 79.5 401.8 179.6 411.3 248.8 446.2 259.4 451.6 272 444.3 272 432.7V68.6C272 63.3 269.4 58.5 264.7 55.6z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/book-open.js
// module id = ohRY
// module chunks = 0